import { AppointmentsSchedulingType } from '@prisma/client';
import { Option } from '../../interfaces';
import {
  AcceptRequestFlowValues,
  RequestKind,
  SchedulingMode,
} from '../../types/appointments';

export const initAcceptRequestFlowValues: AcceptRequestFlowValues = {
  requestKind: 'NEW_APPOINTMENT',
  schedulingMode: 'BOOKING_LINK',
  businessId: '',
  employeeId: '',
  appointmentLengthInMinutes: '',
  priceType: '',
  // Amounts start empty, not 0 — a $0 must be an explicit choice
  price: undefined,
  minPrice: undefined,
  maxPrice: undefined,
  hourlyPrice: undefined,
  depositPrice: undefined,
  startDateTime: '',
  offeredSlots: [],
  additionalAppointments: [],
  isVirtual: false,
  virtualMeetingUrl: '',
  virtualMeetingProvider: null,
  allowOverlapping: true,
  numberOfSessions: 1,
  schedulingType: '',
  bufferDays: '',
  depositPlacement: '',
  customDesignMessage: '',
  requestWaiver: true,
  depositPaid: false,
  depositPaymentMethod: undefined,
  internalNotes: '',
  serviceId: '0',
  businessTripId: '',
  tattooLocation: '',
  bodySide: '',
  tattooSize: '',
  tattooColor: '',
  tattooDetails: '',
  locationCategory: '',
  piercingLocationId: '',
};

export const requestKindOptions: Required<Option<RequestKind>>[] = [
  { value: 'NEW_APPOINTMENT', label: 'Appointment' },
  { value: 'CONSULTATION', label: 'Consultation' },
];

export const getSchedulingModeOptions = (
  clientFirstName: string,
  { allowOfferTimes }: { allowOfferTimes?: boolean } = {},
): Required<Option<SchedulingMode>>[] => [
  { value: 'BOOKING_LINK', label: `Send ${clientFirstName} a booking link` },
  ...(allowOfferTimes
    ? [
        {
          value: 'OFFER_TIMES' as const,
          label: `Offer ${clientFirstName} specific times`,
        },
      ]
    : []),
  { value: 'PICK_TIME', label: 'Choose the date & time myself' },
];

export const sessionCountOptions: Option[] = Array.from(
  { length: 10 },
  (_, i) => ({ value: i + 1, label: String(i + 1) }),
);

export const schedulingTypeOptions: Option<AppointmentsSchedulingType>[] = [
  {
    value: 'FIRST_SESSION',
    label: 'Client should just schedule the first session',
  },
  { value: 'ALL', label: 'Client should schedule all the sessions' },
  {
    value: 'CLIENT_CHOICE',
    label: 'Let the client choose how many to schedule',
  },
];

export const depositPaidOptions: Option[] = [
  { value: false, label: 'No' },
  { value: true, label: 'Yes, already paid' },
];
